import { createContext } from 'react';

import type { DocumentContextType } from './shared/types';

export default createContext<DocumentContextType>(null);
